module.exports = __webpack_public_path__ + "img/farzana-christopher-128.5ba4c0ea.jpg";